import React, { useEffect, useState, useContext } from "react";
import HeaderTitle from "../HederTitle/HeaderTitle";
import { Link } from "react-router-dom";
import { currency } from "../../App";
import axios from "axios";
import { backend_url } from "../../App";
import { WishlistContext } from "../../Context/WishlistContext";
import { FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import LazyVideo from "../LazyVideo/LazyVideo";

const slugify = (text) =>
  (text || "")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+|-+$/g, "");

const BestSeller = () => {
  const [bestSellers, setBestSellers] = useState([]);
  const { toggleWishlist, isWishlisted } = useContext(WishlistContext);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/topsellerretro`);
        const filteredSellers = response.data.filter(
          (item) => item.placeTo === "Topsellers"
        );
        setBestSellers(filteredSellers);
      } catch (error) {
        console.error("Error fetching best sellers:", error);
      }
    };
    fetchBestSellers();
  }, []);

  return (
    <div
      className="relative overflow-hidden px-4 sm:px-8 py-8"
      style={{ background: "linear-gradient(180deg, var(--brand-surface) 0%, var(--brand-bg) 100%)" }}
    >
      {/* Subtle top line */}
      <div className="absolute top-0 left-0 right-0 h-0.5" style={{ background: "linear-gradient(90deg, transparent, var(--brand-primary-500), transparent)" }} />

      <div className="relative max-w-7xl mx-auto">
        {/* Header with badge */}
        <div className="flex flex-col items-center mb-2">
          <span
            className="text-white text-xs font-bold px-4 py-1 rounded-full mb-3"
            style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
          >
            🏆 Best Sellers
          </span>
          <HeaderTitle Header="Aavryaa's Top Sellers" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-2">
          {bestSellers.map((item) => (
            <Link
              key={item._id}
              to={`/product/${item.productId?.id}/${slugify(item.productId?.name)}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col rounded-2xl overflow-hidden bg-white shadow-md
                         border-2 border-[var(--brand-primary-100)]
                         hover:shadow-[0_8px_28px_rgba(124,58,237,0.25)]
                         hover:border-[var(--brand-primary-400)]
                         hover:-translate-y-1.5
                         transition-all duration-300"
            >
              {/* Video */}
              <div className="relative h-72 sm:h-80 overflow-hidden">
                <LazyVideo
                  key={item.video}
                  src={item.video}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Top-seller badge */}
                <div className="absolute top-3 left-3">
                  <span
                    className="text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow"
                    style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                  >
                    ⭐ TOP SELLER
                  </span>
                </div>
                {/* Heart button */}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const pid = item.productId;
                    const price = pid?.old_price
                      ? Math.round((pid.old_price * (100 - pid.new_price)) / 100)
                      : pid?.new_price;
                    toggleWishlist({ id: pid?.id, name: pid?.name, image: pid?.images?.[0] || "", new_price: price });
                  }}
                  className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full flex items-center justify-center shadow-md transition-all duration-200 hover:scale-110 active:scale-95"
                  style={{
                    background: isWishlisted(item.productId?.id)
                      ? "linear-gradient(135deg,var(--brand-primary-600),var(--brand-primary-500))"
                      : "rgba(255,255,255,0.92)",
                    border: isWishlisted(item.productId?.id) ? "none" : "1.5px solid var(--brand-primary-100)",
                  }}
                >
                  {isWishlisted(item.productId?.id)
                    ? <FaHeart size={13} color="white" />
                    : <FiHeart size={13} style={{ color: "var(--brand-primary-600)" }} />
                  }
                </button>
                {/* Quick view on hover */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="bg-white/90 text-[var(--brand-primary-700)] text-xs font-bold px-5 py-2 rounded-full shadow">
                    View Product
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-3 flex flex-col gap-1">
                <p className="text-sm font-semibold text-gray-800 truncate">
                  {item.productId?.name}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[var(--brand-primary-700)] font-bold text-sm">
                    {currency}{item.productId?.old_price && Math.round((item.productId.old_price * (100 - item.productId.new_price)) / 100)}
                  </span>
                  {item.productId?.old_price && (
                    <>
                      <span className="text-gray-400 line-through text-xs">₹{item.productId.old_price}</span>
                      <span className="bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded-full">
                        {item.productId.new_price}% OFF
                      </span>
                    </>
                  )}
                  <span className="text-gray-400 text-xs">
                    /{item.productId?.scale === "Meters" ? "meter" : "piece"}
                  </span>
                </div>
              </div>
            </Link>
          ))}

          {bestSellers.length === 0 && (
            <p className="text-center col-span-4 text-gray-400">No best sellers found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BestSeller;
